import React, { FunctionComponent, ReactElement, useContext } from 'react';
import { HyruleToken } from '@nintendo/hyrule-react-commons';
import HyruleTokenContext from '../contexts/HyruleTokenContext';
import { SearchContext } from '../contexts/SearchContext';
import { usePartOrders } from '../account/hooks/usePartOrders';
import Orders from '../account/orders/Orders';
import Footer from '../Footer';

const GuestOrder: FunctionComponent = (): ReactElement => {
    const searchContext = useContext(SearchContext);
    const token: HyruleToken = useContext(HyruleTokenContext);

    const orderNumber = searchContext?.resolvedOrderNumber || '';
    const correlationId = searchContext?.correlationId || '';

    const { orders, isLoading, isError, isNotFound } = usePartOrders(
        '',
        '',
        token,
        correlationId,
        orderNumber,
    );

    return (
        <>
            <Orders
                orders={orders}
                isLoading={isLoading}
                isError={isError}
                isNotFound={isNotFound}
                orderNumber={orderNumber}
            />
            <Footer />
        </>
    );
};

export default GuestOrder;
